import React from 'react';
import './css/Card.css'

export default class Card extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  render(){
    const {titulo, children, onClick, expandir} = this.props;
    const width = this.props.width === undefined ? 400 : this.props.width;
    const maxWidth = this.props.maxWidth === undefined ? null : this.props.maxWidth;
    return(
      <div
        className="Card"
        style={{width, maxWidth}}
        onClick={() => onClick()}
      >
        <div
          className="Titulo"
          style={{borderRadius: expandir ? null : "15px 15px 15px 15px"}}
        >
          <span style={{textAlign:'center', fontSize:20}}>{titulo}</span>
        </div>
        <div className="Descripcion" style={{display:expandir?"flex":"none"}}>
          {children}
        </div>
      </div>
    )
  }
}
